import { create } from 'zustand';
import type { Channel } from '@disenchantment/types';

interface ChannelsState {
  channelsByServer: Record<string, Channel[]>;
  activeChannelId: string | null;
  /** Voice channel open in the main panel (lobby view, no auto-join). */
  viewingVoiceChannelId: string | null;
  setChannels: (serverId: string, channels: Channel[]) => void;
  setActiveChannel: (id: string | null) => void;
  setViewingVoiceChannel: (id: string | null) => void;
  clear: () => void;
}

export const useChannelsStore = create<ChannelsState>((set) => ({
  channelsByServer: {},
  activeChannelId: null,
  viewingVoiceChannelId: null,
  setChannels: (serverId, channels) =>
    set((s) => ({ channelsByServer: { ...s.channelsByServer, [serverId]: channels } })),
  setActiveChannel: (id) => set({ activeChannelId: id }),
  setViewingVoiceChannel: (id) => set({ viewingVoiceChannelId: id }),
  clear: () =>
    set({ channelsByServer: {}, activeChannelId: null, viewingVoiceChannelId: null }),
}));
